export default "<p>formulario-auth works!</p>\n";